<template>
  <v-tour name="mainTour" :steps="steps" :options="tourOptions" class="app_pg_tour">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          >
          <template>
            <div slot="actions" class="actions">
              <button class="btn_close" @click="tour.stop" title="End Tour">
                <span class="ic-close"></span>
              </button>
              <div class="hide_tour_check">
                <input type="checkbox" id="hideApplicationTour" @click="updateTourStatus(step)">
                <label for="hideApplicationTour">Don't show me this again</label>
              </div>
              <button v-if="!tour.isFirst" @click="tour.previousStep" class="btn btn-primary">Previous step</button>
              <button v-if="!tour.isLast" @click="tour.nextStep" class="btn btn-primary">Next step</button>
              <button v-if="tour.isLast" @click="tour.stop" class="btn btn-primary">Finish Tour</button>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
export default {
  name: 'mainTour',
  props: ['dashboardName'],
  components: {
  },
  data: () => {
    return {
      tourElements: {},
      tourUserStatus: {},
      steps: [],
      tourOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'skip tour',
          buttonPrevious: '<< prev',
          buttonNext: 'next >> ',
          buttonStop: 'finish tour'
        },
        startTimeout: 1000
      }
    }
  },

  mounted () {
    this.loadMainTour()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadTourElements',
      'loadTourUserStatus',
      'loadCurrentPage',
      'loadUpdateTourUserStatus',
      'loadForceResetTourElements'
    ]),

    async loadMainTour () {
      // log login activity
      this.loadLogDashboardActivity({action: 'tour', page: 'tour', link: ''})

      // Get Tour Elements
      this.tourElements = await this.loadTourElements()

      // Get Tour User Status
      this.tourUserStatus = await this.loadTourUserStatus()

      if (this.currentPage === '') {
        this.loadCurrentPage(this.$route.name)
      }

    },
    async resetUserStatusAndReloadTour () {
      if (this.currentPage !== '') {
        this.steps = []
        let tourElementsForCurrentPage = []
        if (this.tourElements[this.currentPage]) {
          tourElementsForCurrentPage = this.tourElements[this.currentPage]
        }
        let tourStatus = []
        if (tourElementsForCurrentPage.length > 0) {
          tourElementsForCurrentPage.forEach((item, i) => {
            let userTourElementStatus = this.tourUserStatus[item.uuid]
            userTourElementStatus.showTour = true
            tourStatus.push(userTourElementStatus)
            let step = {
              target: item.elementId,
              content: item.description,
              params: {
                highlight: false,
                placement: item.position
              },
              uuid: item.uuid
            }
            this.steps.push(step)
          })
        }
        this.startTour()
        await this.loadUpdateTourUserStatus(tourStatus)
        this.loadForceResetTourElements(false)
      }
    },
    async setupTourForCurrentPage () {
      if (this.currentPage !== '' && this.tourElements) {
        this.steps = []
        let tourElementsForCurrentPage = []
        if (this.tourElements[this.currentPage]) {
          tourElementsForCurrentPage = this.tourElements[this.currentPage]
        }

        if (tourElementsForCurrentPage.length > 0) {
          tourElementsForCurrentPage.forEach((item, i) => {
            let userTourElementStatus = this.tourUserStatus[item.uuid]
            if (userTourElementStatus.showTour) {
              let step = {
                target: item.elementId,
                content: item.description,
                params: {
                  highlight: false,
                  placement: item.position
                },
                uuid: item.uuid
              }
              this.steps.push(step)
            }
          })
        }
        setTimeout(() => {
          this.startTour()
        },1000)
      }
    },
    startTour () {
      if (this.isTourEnabled) {
        this.$tours['mainTour'].start()
      }
    },
    async updateTourStatus (item) {
      let userTourElementStatus = this.tourUserStatus[item.uuid]
      userTourElementStatus.showTour = false
      let tourStatus = []
      tourStatus.push(userTourElementStatus)
      await this.loadUpdateTourUserStatus(tourStatus)
    }
  },

  computed: {
    ...mapState({
      'currentPage': state => state.user.currentPage,
      'forceResetTourElements': state => state.user.forceResetTourElements,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isTourEnabled () {
      let tourFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TOUR_FEATURE_ID]
      if (tourFeature) {
        return tourFeature.enabled
      }
      return false
    }
  },

  watch: {
    // current page
    currentPage (newCurrentPage) {
      if (this.isTourEnabled) {
        this.$tours['mainTour'].stop()
      }
      setTimeout(() => {
        this.setupTourForCurrentPage()
      },1000)
    },
    forceResetTourElements (newForceResetTourElements) {
      if (newForceResetTourElements) {
        this.resetUserStatusAndReloadTour ()
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/MainTour.vue